import styled from 'styled-components';
import { getSafeAreaValue } from '../../../../styled/theme/helpers/getSafeAreaValue';
import { Breakpoints } from '../../../../styled/constants';
import {
  ellipsisText,
  FlexBetween,
  FlexColumn
} from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { PhoneButtonContainer } from '../../BottomPhoneButton/styled';

export const FooterContainer = styled(FlexBetween)`
  width: 100%;
  padding: 10px 15px ${({ theme }) => getSafeAreaValue(theme, 'bottom', 15)};
  gap: 10px;

  ${PhoneButtonContainer} {
    flex: 0 0 auto;
    flex-shrink: 0;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 15px 20px;
  }
`;

export const FooterContent = styled(FlexColumn)`
  gap: 5px;
  flex: 1 1 auto;
  min-width: 0;
`;

export const ContentText = styled(Typography)`
  ${ellipsisText};
  color: ${({ theme }) => theme.colors.background.primary};
`;
